<div class="content-container">
  <div class="picture-container">
    <div class="container">
      <img src="../../assets/seatsformeasurement.svg" class="img-size" />
    </div>
    <div class="container">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>h<sub>1</sub></mat-label>
        <input matInput type="number" [ngModel]="baseDimension?.box?.height"
          (ngModelChange)="baseDimension.box.height = $event" autocomplete="off" (keypress)="integerOnly($event)">
        <mat-hint class="mat-error" *ngIf="!getH1ValidState()">
          {{error?.greaterZeroInfo}}
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>w<sub>1</sub></mat-label>
        <input matInput type="number" [ngModel]="baseDimension?.box?.length" disabled (keypress)="integerOnly($event)">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>w<sub>2</sub></mat-label>
        <input matInput type="number" [ngModel]="adjustableSeat?.length85"
          (ngModelChange)="adjustableSeat.length85 = $event" autocomplete="off"
          (keypress)="integerOnlyWithNegatives($event)">
        <mat-hint class="mat-error" *ngIf="!getW2ValidState()">
          {{error?.minusOneOrW1MaxInfo}}
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>w<sub>3</sub></mat-label>
        <input matInput type="number" [ngModel]="adjustableSeat?.length60"
          (ngModelChange)="adjustableSeat.length60 = $event" autocomplete="off"
          (keypress)="integerOnlyWithNegatives($event)">
        <mat-hint class="mat-error" *ngIf="!getW3ValidState()">
          {{error?.minusOneOrW1MaxInfo}}
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>w<sub>4</sub></mat-label>
        <input matInput type="number" [ngModel]="adjustableSeat?.lengthSeatSurface"
          (ngModelChange)="adjustableSeat.lengthSeatSurface = $event" autoComplete="off"
          (keypress)="integerOnlyWithNegatives($event)">
        <mat-hint class="mat-error" *ngIf="!getW4ValidState()">
          {{error?.minusOneOrW1MaxInfo}}
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>h<sub>2</sub></mat-label>
        <input matInput type="number" [ngModel]="adjustableSeat?.heightLowerEdge"
          (ngModelChange)="adjustableSeat.heightLowerEdge = $event" autocomplete="off" (keypress)="integerOnly($event)">
        <mat-hint class="mat-error" *ngIf="!getH2ValidState()">
          {{error?.zeroOrH1MaxInfo}}
        </mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="container">
    <!-- <mat-form-field appearance="outline" class="form-field">
      <mat-label>Seat Capacity</mat-label>
      <input matInput type="number" step="0.5" (keypress)="seatCapacityValidation($event)" min="1" [ngModel]="seat?.seatAmount"
        (ngModelChange)="seat.seatAmount = $event" [disabled]="seat?.seatAmountEditable === false" autocomplete="off">
    </mat-form-field> -->
    <mat-form-field class="form-field">
      <mat-label>Seat capacity</mat-label>
      <mat-select class="text-right" [disabled]="seat?.seatAmountEditable === false" [value]="seat?.seatAmount"
        (selectionChange)="changeSeatCapacity($event.value)">
        <mat-option class="select-without-checkbox" *ngFor="let capacity of seatCapacities" [value]="capacity">
          {{capacity}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="adjustableSeat?.groundSupport"
      (ngModelChange)="adjustableSeat.groundSupport = $event" class="margin-right form-field">
      Floor support
    </mat-checkbox>
    <mat-checkbox *ngIf="showFeatureSeatFootrest" [ngModelOptions]="{standalone: true}"
      [ngModel]="adjustableSeat?.footRest" (ngModelChange)="adjustableSeat.footRest = $event"
      class="margin-right form-field">
      Footrest
    </mat-checkbox>
    <div *ngIf="show">
      <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="adjustableSeat?.tableBehind"
        (ngModelChange)="adjustableSeat.tableBehind = $event" class="margin-right form-field">
        Rear Table
      </mat-checkbox>
      <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="adjustableSeat?.tableForOwnSeat"
        (ngModelChange)="adjustableSeat.tableForOwnSeat = $event" class="margin-right form-field">
        Table For Your Own Place
      </mat-checkbox>
      <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="adjustableSeat?.socket"
        (ngModelChange)="adjustableSeat.socket = $event" class="margin-right form-field">
        Socket
      </mat-checkbox>
      <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="adjustableSeat?.backrestAdjustable"
        (ngModelChange)="adjustableSeat.backrestAdjustable = $event" class="margin-right form-field">
        Adjustable Backrest
      </mat-checkbox>
      <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="adjustableSeat?.armrestAvailable"
        (ngModelChange)="adjustableSeat.armrestAvailable = $event" class="margin-right form-field">
        Armrest Available
      </mat-checkbox>
      <mat-checkbox [ngModelOptions]="{standalone: true}" *ngIf="armrestBetweenSeat != null"
        [ngModel]="armrestBetweenSeat?.armrestBetweenSeats"
        (ngModelChange)="armrestBetweenSeat.armrestBetweenSeats = $event" class="margin-right form-field">
        Armrest In Between
      </mat-checkbox>
    </div>
  </div>
</div>